const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemainIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 6798"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 157547",
    style: {
      fill: "none"
    },
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.285-805.08-4.125-4.12a10.328 10.328 0 0 1-1.035.564 8.781 8.781 0 0 1-1.13.44v-1.856q.232-.092.448-.2t.437-.229l-9.923-9.923a7.826 7.826 0 0 0-.694 1.721 7.107 7.107 0 0 0-.247 1.876 7.114 7.114 0 0 0 .522 2.675 7.175 7.175 0 0 0 1.623 2.4l.745.745v-3.215h1.761v6.322h-6.323v-1.761h3.432l-.854-.817a8.824 8.824 0 0 1-2.031-3.024 9.06 9.06 0 0 1-.638-3.325 9.1 9.1 0 0 1 .36-2.573 9.013 9.013 0 0 1 1.051-2.316l-4.125-4.125 1.261-1.259 20.74 20.745zm-1.2-7.053-1.31-1.309a7.542 7.542 0 0 0 .674-1.688 7.127 7.127 0 0 0 .238-1.844 7.114 7.114 0 0 0-.522-2.675 7.176 7.176 0 0 0-1.623-2.4l-.745-.745v3.215H92.04v-6.321h6.322v1.761H94.93l.854.817a8.824 8.824 0 0 1 2.031 3.024 9.06 9.06 0 0 1 .638 3.325 8.876 8.876 0 0 1-.36 2.543 10.186 10.186 0 0 1-1.005 2.297zm-11.2-11.2-1.3-1.3a8.222 8.222 0 0 1 1.02-.541 11.468 11.468 0 0 1 1.1-.417v1.856q-.215.092-.421.185a3.132 3.132 0 0 0-.392.22z",
    transform: "translate(-72.54 832.08)",
    style: {
      fill: "#527ff2"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemainIcon);
export default __webpack_public_path__ + "static/media/remain_icon.6575075c079189b07dc802111312dc92.svg";
export { ForwardRef as ReactComponent };